import type { ReactNode } from 'react'

interface StatusScreenProps {
  title: string
  message?: string | undefined
  /** Действия (кнопки) под сообщением. */
  children?: ReactNode
}

// Полноэкранный статус вместо контента страницы — терминальные состояния входа
// во встречу (завершена/отменена/не найдена/битая ссылка) и подобные тупики,
// где тост слишком мимолётен, а форма ввода уже не имеет смысла.
export function StatusScreen({ title, message, children }: StatusScreenProps) {
  return (
    <section className="container-x flex flex-col items-center justify-center gap-6 px-6 py-24 text-center">
      <div className="flex flex-col items-center gap-2">
        <h1 className="t-h2 text-text-primary">{title}</h1>
        {message && <p className="text-text-secondary">{message}</p>}
      </div>
      {children && <div className="flex flex-wrap justify-center gap-3">{children}</div>}
    </section>
  )
}
